import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';

import Button from '@material-ui/core/Button';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
//import Tooltip from '@material-ui/core/Tooltip';
import { withStyles } from '@material-ui/core/styles';

import AddIcon from '@material-ui/icons/Add';

import grey from '@material-ui/core/colors/grey';
import amber from '@material-ui/core/colors/amber';

import {
  Filter,
  FilterButton,
  FilterDivider,
  FilterItem,
} from 'components/core/Filter';
import {
  helpDispatch,
  Tooltip,
  TooltipTypes,
} from 'components/admin/Help';
import { startEditTimecardListFilter } from '../../../store/actions/filters';

const styles = theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  addButton: {
    backgroundColor: amber[500],
    color: "#fff",
    marginLeft: theme.spacing.unit*4,
    zIndex: theme.zIndex.overlay + 1,
  },
  tooltip: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.text.primary,
    boxShadow: theme.shadows[1],
    fontSize: 11,
    padding: 0,
    opacity: 1,
  },
});

const TimecardsFilter = (props) => {
  const {
    classes,
    handleAdd,
    receiptListFilter,
    timecardListFilter,
    startEditReceiptListFilter,
    startEditTimecardListFilter,
  } = props;

  return(
    <div className={classes.root}>
      <Filter>
        <FilterItem>
          <FilterButton
            selected={timecardListFilter.type === "all"}
            onClick={() => startEditTimecardListFilter({type: "all"})}>
            All
          </FilterButton>
        </FilterItem>
        <FilterDivider />
        <FilterItem caption="Filter">
          <FilterButton
            selected={timecardListFilter.type === "invoiced"}
            onClick={() => startEditTimecardListFilter({type: "invoiced"})}>
            Invoiced
          </FilterButton>
          <FilterButton
            selected={timecardListFilter.type === "not-invoiced"}
            onClick={() => startEditTimecardListFilter({type: "not-invoiced"})}>
            Not Invoiced
          </FilterButton>
        </FilterItem>
        <FilterDivider />
        <FilterItem caption="Sort">
          <FilterButton
            selected={timecardListFilter.orderBy === "date"}
            onClick={() => {
              let direction = "desc";
              if (timecardListFilter.orderBy === "date") {
                direction = timecardListFilter.direction === "asc" ? "desc" : "asc";
              }

              startEditTimecardListFilter({orderBy: "date", direction: direction})
            }}>
            Date
          </FilterButton>
          <FilterButton
            selected={timecardListFilter.orderBy === "client"}
            onClick={() => {
              let direction = "asc";
              if (timecardListFilter.orderBy === "client") {
                direction = timecardListFilter.direction === "asc" ? "desc" : "asc";
              }

              startEditTimecardListFilter({orderBy: "client", direction: direction})
            }}>
            Client
          </FilterButton>
          <FilterButton
            selected={timecardListFilter.orderBy === "crew"}
            onClick={() => {
              let direction = "asc";
              if (timecardListFilter.orderBy === "crew") {
                direction = timecardListFilter.direction === "asc" ? "desc" : "asc";
              }

              startEditTimecardListFilter({orderBy: "crew", direction: direction})
            }}>
            Crew
          </FilterButton>
          <FilterButton
            selected={timecardListFilter.orderBy === "job"}
            onClick={() => {
              let direction = "asc";
              if (timecardListFilter.orderBy === "job") {
                direction = timecardListFilter.direction === "asc" ? "desc" : "asc";
              }

              startEditTimecardListFilter({orderBy: "job", direction: direction})
            }}>
            Job
          </FilterButton>
        </FilterItem>
        <FilterDivider />
        <Tooltip type={TooltipTypes.TIMECARD_FILTER_SHOW_ARCHIVED} placement="bottom">
          <FilterItem hideCaption>
            <FormControlLabel
              className={classes.optional}
              control={
                <Switch
                  color="primary"
                  checked={timecardListFilter.showArchived}
                  onChange={() => {
                    startEditTimecardListFilter({showArchived: !timecardListFilter.showArchived});
                    helpDispatch();
                  }}
                />
              }
              label="SHOW ARCHIVED"
            />
          </FilterItem>
        </Tooltip>
      </Filter>

      <Tooltip type={TooltipTypes.ADD_TIMECARD} placement="left">
        <Button
          className={classes.addButton}
          variant="fab"
          aria-label="add"
          onClick={() => {
            handleAdd();
            helpDispatch(TooltipTypes.ADD_TIMECARD);
          }}
        >
          <AddIcon />
        </Button>
      </Tooltip>
    </div>
  );
};

TimecardsFilter.propTypes = {
  classes: PropTypes.object.isRequired,
};


const mapStateToProps = (state) => {
  const timecardListFilter = state.filters.timecardList ? state.filters.timecardList : {};

  return({
    timecardListFilter,
  });
};

const mapDispatchToProps = (dispatch) => ({
  startEditTimecardListFilter: (updates) => dispatch(startEditTimecardListFilter(updates)),
});

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(TimecardsFilter);



// WEBPACK FOOTER //
// ./src/components/admin/Timecards/TimecardsFilter.jsx